import { Injectable } from '@jack-henry/frontend-utils/di';
import { CompaniesClient, CompanySearchModelDto } from '@treasury/api/bo';
import CompanyRequests from '../../requests/companies/company-requests';
import { CompanySearchResult } from './entities/company-search-result.entity';

export enum CompanySearchField {
    CompanyName = 'Company+Name',
    CompanyId = 'Company+Id',
    CompanyTaxNumber = 'TAX+ID+Number',
    CompanyCifNumber = 'CIF+Number',
}

@Injectable()
export class CompanySearchService {
    constructor(private readonly companiesClient: CompaniesClient) {}

    public static async fetchCompanies() {
        return CompanyRequests.fetchCompanies();
    }

    public static async fetchNotOnboardedCompanies(parameters: object) {
        return CompanyRequests.fetchNotOnboardedCompanies(parameters);
    }

    /**
     * Searches for companies by company name.
     */
    public async getCompanies() {
        const resp = await this.companiesClient.companiesGet({
            searchType: CompanySearchField.CompanyName,
            searchValue: '',
        });

        return (
            resp.data
                .map(c => new CompanySearchResult(c))
                // The data from the API contains some invalid entries that we need to filter out.
                .filter(c => !['0', '1', 'items'].includes(c.cifNumber ?? ''))
        );
    }

    public async getNotOnboardedCompanies(searchTerm: string) {
        const notOnboardedCompanies = await Promise.all(
            [
                CompanySearchField.CompanyName,
                CompanySearchField.CompanyId,
                CompanySearchField.CompanyTaxNumber,
                CompanySearchField.CompanyCifNumber,
            ].map(async field => {
                const resp = await CompanyRequests.fetchNotOnboardedCompanies({
                    searchType: field,
                    searchValue: searchTerm,
                });

                return (resp ?? []).map((c: CompanySearchModelDto) => {
                    const companySearchResult = new CompanySearchResult(c);
                    companySearchResult.status = 'Not onboarded';
                    return companySearchResult;
                });
            })
        );

        return notOnboardedCompanies
            .flat()
            .filter(c => !['0', '1', 'items'].includes(c.cifNumber ?? ''));
    }
}

export default CompanySearchService;
